import { render, staticRenderFns } from "./tester.vue?vue&type=template&id=064f6694&scoped=true&lang=html&"
import script from "./tester.vue?vue&type=script&lang=js&"
export * from "./tester.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064f6694",
  null
  
)

export default component.exports